"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isResultsTableColumnTitleProperty = exports.resultsTableColumnTitlePropertyDefinition = void 0;
exports.resultsTableColumnTitlePropertyDefinition = {
    view: { label: 'Results Table Column Title' },
    constraints: [
        {
            name: 'required',
            argument: true,
        },
        {
            name: 'maxLength',
            argument: 50,
        },
    ],
    type: 'text',
    multiple: false,
    name: 'results-table-column-title',
};
const isResultsTableColumnTitleProperty = (prop) => {
    return prop.name === exports.resultsTableColumnTitlePropertyDefinition.name;
};
exports.isResultsTableColumnTitleProperty = isResultsTableColumnTitleProperty;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoicmVzdWx0cy10YWJsZS1jb2x1bW4tdGl0bGUucHJvcGVydHkuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi9zcmMvcHJvcGVydGllcy9yZXN1bHRzLXRhYmxlLWNvbHVtbi10aXRsZS5wcm9wZXJ0eS50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7QUFFYSxRQUFBLHlDQUF5QyxHQUFHO0lBQ3ZELElBQUksRUFBRSxFQUFFLEtBQUssRUFBRSw0QkFBNEIsRUFBRTtJQUM3QyxXQUFXLEVBQUU7UUFDWDtZQUNFLElBQUksRUFBRSxVQUFVO1lBQ2hCLFFBQVEsRUFBRSxJQUFJO1NBQ2Y7UUFDRDtZQUNFLElBQUksRUFBRSxXQUFXO1lBQ2pCLFFBQVEsRUFBRSxFQUFFO1NBQ2I7S0FDRjtJQUNELElBQUksRUFBRSxNQUFNO0lBQ1osUUFBUSxFQUFFLEtBQUs7SUFDZixJQUFJLEVBQUUsNEJBQTRCO0NBQ0gsQ0FBQTtBQUkxQixNQUFNLGlDQUFpQyxHQUFHLENBQUMsSUFBa0IsRUFBMkMsRUFBRTtJQUMvRyxPQUFPLElBQUksQ0FBQyxJQUFJLEtBQUssaURBQXlDLENBQUMsSUFBSSxDQUFBO0FBQ3JFLENBQUMsQ0FBQTtBQUZZLFFBQUEsaUNBQWlDLHFDQUU3QyJ9